<template>

    <div>
        <!-- 登录页面 -->
        <div v-if="step === 1">
            <loginPage ref="loginPage"></loginPage>
        </div>

        <div v-if="step === 2" class="back-div">
            <div class="main-page" ref="mainPage">
                <!--<van-button @click="testPay">支付</van-button>-->
                <div class="dialog-mask" v-show="diyDialogShow">
                    <div class="diy-dialog">
                        <div style="text-align: center;height: 30px;line-height: 30px;">温馨提示</div>
                        <div style="padding: 3px 15px;text-align: left;box-sizing: border-box;margin-top: 10px;">
                            即将打开支付页面，请点击"立即支付"按钮完成支付
                        </div>
                        <div class="diy-dialog-buttons">
                            <div @click="closeDiyDialog()"
                                 style="flex: 1;text-align: center;height: 45px;line-height: 45px;">
                                <a style="color: #888888">取消</a>
                            </div>
                            <div style="flex: 1;text-align: center;height: 45px;line-height: 45px;border-left: 1px solid #f0f0f0;">
                                <a target="_blank" :href="payUrl" @click="closeDiyDialog()"
                                   style="color:#e73d50;">立即支付</a>
                            </div>
                        </div>

                    </div>
                </div>

                <iframe v-if="true" allowfullscreen ref="gameIframe" :src="gameUrl" frameborder="0" scrolling="no"
                        width="100%" :style="iframeStyle">
                </iframe>

                <van-notice-bar  v-if="showNotice" delay="0"  :style="noticeStyle" style="font-weight: bold; color: #e0a309;pointer-events: none;position: absolute;top: 100px;left: 50%; transform: translate(-50%, -50%); font-size: 14px;width: 100%;max-width: 450px; height: 35px;background-color: rgba(0,0,0,.4)"
                                 speed="30"  :text="noticeMessage" @replay="hideNotice"/>

                <van-dialog :style="dialogStyle" v-model="payShow" class="pay-dialog" :showConfirmButton="false">
                    <pay ref="pay"></pay>
                </van-dialog>

                <van-dialog :style="dialogStyle" v-model="payJxfShow" class="pay-dialog" :showConfirmButton="false">
                    <pay-jxf ref="payJxf"></pay-jxf>
                </van-dialog>

                <van-dialog class="pay-code-dialog" v-model="payCodeShow" v-if="payCodeShow" :showConfirmButton="false">
                    <pay-code ref="payCode"></pay-code>
                </van-dialog>

                <van-popup class="pay-code-dialog" v-model="hasRedShow" v-if="hasRedShow" position="center" :style="{ width: '100%'}" style="background: transparent;">
                    <img @click="openFuliPageFromRed" src="../../assets/has-red-image.png" style="width: 80%;">
                    <img @click="hasRedShow = false" src="../../assets/close-round.png" style="width: 25px;height: 25px;position: absolute;top: 5px;right: 15px;opacity: .6">
                </van-popup>

                <van-dialog :style="dialogStyle" class="main-dialog" v-model="videoPageDialogShow"
                            :showConfirmButton="false">
                    <videoPage ref="videoPage" v-if="videoPageShow"></videoPage>
                </van-dialog>

                <van-dialog :style="dialogStyle" class="main-dialog" v-model="realNameShow" :showConfirmButton="false">
                    <real-name ref="realNameDialog" v-if="realNameShow"></real-name>
                </van-dialog>

                <van-dialog :style="dialogStyle" class="main-dialog" v-model="bindTelShow" :showConfirmButton="false">
                    <bind-tel ref="bindTelDialog" v-if="bindTelShow"></bind-tel>
                </van-dialog>

<!--                <van-dialog :style="dialogStyle" class="main-dialog" v-model="mainDialogShow" v-if="mainDialogShow" close-on-click-overlay :showConfirmButton="false">
                    <iframe :src="iframeUrl" frameborder="0" scrolling="no" style="width: 100%;height: 340px;"/>
                </van-dialog>-->

                <sdk-frame-shell v-model="mainDialogShow" :src="iframeUrl" />

                <van-popup v-model="iframeDialogShow" class="iframe-dialog" position="center" :style="{ width: '100%', height: '100%' }" >
                    <div @click="iframeDialogShow = false" style="width: 35px;height: 35px;position: absolute;top: 10px;left: 10px;
                            background-color: rgba(255,255,255,.2);text-align: center;padding-top: 2px; box-sizing: border-box; border-radius: 4px;">
                        <img src="../../assets/back.png" style="width: 30px;">
                    </div>
                    <iframe v-if="iframeDialogShow" allowfullscreen ref="drawIframe" :src="drawUrl" frameborder="0" scrolling="no"
                             width="100%" height="100%">
                    </iframe>
                </van-popup>

                <div v-if="isShow" class="xuanfu" id="moveDiv"
                     @mousedown="down($event)"
                     @touchstart="down($event)"
                     @mousemove="move($event)"
                     @touchmove="move($event)"
                     @mouseover="end($event)"
                     @mouseleave="move($event)"
                     @mouseup="end($event)"
                     @touchend="end($event)"
                     @click="showMainWindow">

                    <van-image  :src="logoRoundUrl" width="50px" height="50px"></van-image>
                    <!--<van-image class="has-red-icon" v-else :src="hasRedIcon" width="50px" height="50px"></van-image>-->
                </div>

                <div v-if="showGiveGiftButton" class="zeng-icon-view" @click="showGiveGiftPage">
                </div>

                <div v-show="false">
                    <van-count-down
                            ref="countDown"
                            :time="time"
                            :auto-start="false"
                            format="ss"
                            @finish="finish"
                    />
                </div>
            </div>
            <van-overlay :show="openPageShow" @click="openPageShow = false">
                <div class="right-panel">
                    <van-icon @click="closeOutsidePage" style="font-size: 25px;" name="arrow-down"/>
                    <iframe ref="webview_iframe" v-show="true" style="overflow-x:auto;overflow-y:auto"
                            allowfullscreen
                            :src="openPageUrl"
                            frameborder="0"
                            width="100%"
                            height="100%" scrolling="yes">
                    </iframe>
                </div>
            </van-overlay>

            <div v-if="giveGiftPageShow" @click="giveGiftPageShow = false" class="give-gift-view">
                <div class="give-top-bg" @click.stop>
                    <div class="give-top-line">
                        <div style="width: 80px;text-align: right;">账号：</div>
                        <div>{{giveGiftResult.userName}}</div>
                    </div>
                    <div class="give-top-line">
                        <div style="width: 80px;text-align: right;">区服：</div>
                        <div>{{giveGiftResult.serverName}}</div>
                    </div>
                    <div class="give-top-line">
                        <div style="width: 80px;text-align: right;">角色名：</div>
                        <div>{{giveGiftResult.roleName}}</div>
                    </div>
                    <div class="give-top-line">
                        <div style="width: 80px;text-align: right;">VIP等级：</div>
                        <div>{{giveGiftResult.vip}}</div>
                    </div>
                    <div class="give-top-line">
                        <div style="width: 80px;text-align: right;">创建时间：</div>
                        <div>{{giveGiftResult.addTime}}</div>
                    </div>
                    <div class="give-top-line">
                        <div style="width: 80px;text-align: right;">赠送状态：</div>
                        <div>{{giveGiftResult.sendStatus}}</div>
                    </div>
                </div>
                <div class="give-main-bg"  @click.stop>
                    <img src="../../assets/give/main_bg.png" style="width: 100%;">

                    <div style="position: absolute;bottom: 27px;right: 55px;display: flex;font-size: 12px;">
                        <div style="width: 130px;height:22px;background-color: rgba(0,0,0,0.4);border-radius: 2px;">
<!--                            <img src="../../assets/give/input_bg.png" style="width: 130px;height: 24px;">-->
                            <img v-if="giveGiftInputTipsShow" src="../../assets/give/input_tips.png" style="width: 110px;position: absolute;left: 10px;top: 4px">
                            <input v-model="giveGiftRoleName" style="width: 110px;height: 20px;background: transparent;border: none;position: absolute;left: 10px;top: 0">
                        </div>
                        <img @click="submitGiveGift" src="../../assets/give/submit_btn.png" style="width: 50px;object-fit: contain;margin-left: 8px;cursor: pointer;">
                    </div>
                </div>
            </div>

            <van-popup class="popup-center" v-model="consumePromotionDialogShow" v-if="consumePromotionDialogShow" position="center" :style="{ width: '100%'}" style="background: transparent;">
                <div style="display: flex;flex-direction: column;align-items: center;">
                    <div style="height: 20px;position: absolute;right: 25%;top: 0;">
                        <img @click="consumePromotionDialogShow = false" src="../../assets/consume/dialog/close.png" style="width: 20px;height: 20px;">
                    </div>
                    <img src="../../assets/consume/dialog/bg-main.png" style="width: 80%;max-width: 380px;">
                    <img @click="openConsumePage" src="../../assets/consume/dialog/button.png" style="width: 150px;">
                    <div style="text-align: center;">
                        <van-checkbox style="justify-content: center;" v-model="hideConsumeDialogValue" icon-size="12px" shape="square" checked-color="#CE9825">
                            <span style="color: #e7e7e7;font-size: 12px;">今日不再显示</span>
                        </van-checkbox>
                    </div>
                </div>
            </van-popup>

            <van-popup  v-model="consumePermissionDialogShow" v-if="consumePermissionDialogShow" position="center" :style="{ width: '100%'}" style="background: transparent;">
                <div class="cp-dialog-view">
                    <div v-if="consumePermissionDialogStep === 1" style="text-align: left;color: #75321C;font-weight: bold;">
                        <div style="text-align: center;">关于充值排行榜的信息公开授权</div>
                        <div style="font-size: 11px;margin-top: 10px;">
                            亲爱的玩家，为了为您提供充值排名竞赛服务，我们需要根据您的充值金额进行全服排名并向所有玩家公示。<br>
                            <br>
                            为此，我们将处理并公开您的以下敏感个人信息：<br>
                            <br>
                            1.您的游戏角色名<br>
                            2.您在本活动期间的累计充值金额({{consumeStartTime}}-{{consumeEndTime}})<br>
                            <br>
                            公开范围与方式：<br>
                            您的上述信息将在活动结束后，于游戏内的【全服充值排行榜,官方公众号，官方短视频账号】中向全体玩家公示。<br>
                            <br>
                            请您知悉，公开您的充值金额可能会使你受到其他玩家的更多关注，甚至不必要的打扰。请您谨慎授权。<br>
                            <br>
                            您是否理解并同意以上信息处理规则？
                        </div>

                        <div style="display: flex;justify-content: space-between;width: calc(80% - 30px); height: 40px;padding: 0 25px;position: absolute;bottom: 15px;">
                            <img @click="consumePermissionDialogShow = false" src="../../assets/consume/permission/button_cancel.png" style="width: 80px;">
                            <img @click="consumePermissionDialogStep = 2" src="../../assets/consume/permission/button_next.png" style="width: 80px;">
                        </div>
                    </div>

                    <div v-if="consumePermissionDialogStep === 2" style="text-align: left;color: #75321C;font-weight: bold;">
                        <div style="text-align: center;">请确认是否公开您的信息</div>
                        <div style="font-size: 11px;margin-top: 10px;">
                            请选择您是否同意在排行榜中公开您的角色名和充值金额：<br>
                            <br>
                            <div @click="consumePermissionAgree = 1" style="display: flex;align-items: center;cursor:pointer;">
                                <img v-if="consumePermissionAgree === 1" src="../../assets/checkbox_selected.png" style="width: 16px;"/>
                                <img v-else src="../../assets/checkbox_none.png" style="width: 16px;"/>
                                <div style="margin-left: 5px;">我同意</div>
                            </div>

                            我明确同意，在【全服充值排行榜，官方公众号，官方短视频账号】中向所有玩家公开我的【角色名】和【充值金额】。<br>
                            <div @click="consumePermissionAgree = 2" style="display: flex;align-items: center;margin-top: 20px;cursor:pointer;">
                                <img v-if="consumePermissionAgree === 2" src="../../assets/checkbox_selected.png" style="width: 16px;"/>
                                <img v-else src="../../assets/checkbox_none.png" style="width: 16px;"/>
                                <div style="margin-left: 5px;">我拒绝</div>
                            </div>
                            我拒绝公开金额。我将正常参与排名和获得奖励，但我的信息在榜单上将以“匿名玩家”的形式展示。<br>
                            （温馨提示：您的选择不会影响您参与活动和领取排名奖励的资格，仅影响榜单信息的展示方式。）
                        </div>

                        <div style="display: flex;justify-content: space-between;width: calc(80% - 30px); height: 40px;padding: 0 25px;position: absolute;bottom: 15px;">
                            <img @click="consumePermissionDialogShow = false" src="../../assets/consume/permission/button_cancel.png" style="width: 80px;">
                            <img @click="submitConsumeUserSet" src="../../assets/consume/permission/button_ok.png" style="width: 80px;">
                        </div>
                    </div>
                </div>
            </van-popup>

            <van-popup  v-model="consumeMainDialogShow" v-if="consumeMainDialogShow" position="center" :style="{ width: '100%'}" style="background: transparent;">
                <div class="consume-main-view">
                    <img src="../../assets/consume/main/bg_main.png" style="width: 100%;height: calc(70vh - 50px); position: absolute;left: 0;top: 50px; z-index: -1">

                    <div style="width: 100%;height: 30%;display: flex;">
                        <div v-if="consumeMainDataList[1]" class="consume-top3-view">
                            <img :src="consumeMainDataList[1].ch" style="width: 100%;height: 40px;">
                            <div style="width: 36px;height: 36px;position: relative;margin-top: 5px;">
                                <img :src="consumeMainDataList[1].tx" style="width: 36px;height: 36px;border-radius: 36px;">
                                <img :src="consumeMainDataList[1].txk" style="width: 50px;height: 50px;position: absolute;top: -7px;left: -7px;">
                            </div>
                            <div v-if="!consumeMainDataList[1].serverName" class="consume-top3-name-view">
                                {{consumeMainDataList[1].roleName}}
                            </div>
                            <div v-else class="consume-top3-name-view">
                                <span>{{consumeMainDataList[1].roleName}}</span>
                                <span style="font-size: 8px;">{{consumeMainDataList[1].serverName}}</span>
                            </div>
                            <div style="display: flex;align-items: flex-end;">
                                <img src="../../assets/consume/main/label_total.png" style="width: 50px;">
                                <span class="consume-label-amount">{{consumeMainDataList[1].money}}</span>
                            </div>
                        </div>
                        <div v-else class="consume-top3-view">
                            <div style="font-size: 14px;color: #ffffff;margin-top: 60px;">暂无数据</div>
                        </div>

                        <div v-if="consumeMainDataList[0]" class="consume-top3-view"  style="margin-top: 0;">
                            <img :src="consumeMainDataList[0].ch" style="width: 100%;height: 40px;">
                            <div style="width: 36px;height: 36px;position: relative;margin-top: 5px;">
                                <img :src="consumeMainDataList[0].tx" style="width: 36px;height: 36px;border-radius: 36px;">
                                <img :src="consumeMainDataList[0].txk" style="width: 50px;height: 50px;position: absolute;top: -7px;left: -7px;">
                            </div>
                            <div v-if="!consumeMainDataList[0].serverName" class="consume-top3-name-view">
                                {{consumeMainDataList[0].roleName}}
                            </div>
                            <div v-else class="consume-top3-name-view">
                                <span>{{consumeMainDataList[0].roleName}}</span>
                                <span style="font-size: 8px;">{{consumeMainDataList[0].serverName}}</span>
                            </div>
                            <div style="display: flex;align-items: flex-end;">
                                <img src="../../assets/consume/main/label_total.png" style="width: 50px;">
                                <span class="consume-label-amount">{{consumeMainDataList[0].money}}</span>
                            </div>
                        </div>
                        <div v-else class="consume-top3-view">
                            <div style="font-size: 14px;color: #ffffff;margin-top: 60px;">暂无数据</div>
                        </div>

                        <div v-if="consumeMainDataList[2]" class="consume-top3-view">
                            <img :src="consumeMainDataList[2].ch" style="width: 100%;height: 40px;">
                            <div style="width: 36px;height: 36px;position: relative;margin-top: 5px;">
                                <img :src="consumeMainDataList[2].tx" style="width: 36px;height: 36px;border-radius: 36px;">
                                <img :src="consumeMainDataList[2].txk" style="width: 50px;height: 50px;position: absolute;top: -7px;left: -7px;">
                            </div>
                            <div v-if="!consumeMainDataList[2].serverName" class="consume-top3-name-view">
                                {{consumeMainDataList[2].roleName}}
                            </div>
                            <div v-else class="consume-top3-name-view">
                                <span>{{consumeMainDataList[2].roleName}}</span>
                                <span style="font-size: 8px;">{{consumeMainDataList[2].serverName}}</span>
                            </div>
                            <div style="display: flex;align-items: flex-end;">
                                <img src="../../assets/consume/main/label_total.png" style="width: 50px;">
                                <span class="consume-label-amount">{{consumeMainDataList[2].money}}</span>
                            </div>
                        </div>
                        <div v-else class="consume-top3-view">
                            <div style="font-size: 14px;color: #ffffff;margin-top: 60px;">暂无数据</div>
                        </div>

                    </div>

                    <div class="consume-main-list-view">
                        <div v-if="index > 2" v-for="(item,index) in consumeMainDataList" class="consume-main-item-view">
                            <div class="consume-main-index">{{item.ranking}}</div>
                            <div style="width: 36px;height: 36px;position: relative;margin-top: 5px;">
                                <img :src="item.tx" style="width: 36px;height: 36px;border-radius: 36px;">
                                <img :src="item.txk" style="width: 50px;height: 50px;position: absolute;top: -7px;left: -7px;">
                            </div>
                            <div v-if="!item.serverName" class="consume-main-name">
                                {{item.roleName}}
                            </div>
                            <div v-else class="consume-main-name">
                                <div>{{item.roleName}}</div>
                                <div style="font-size: 10px;">{{item.serverName}}</div>
                            </div>
                            <div style="display: flex;flex-direction: column;">
                                <img src="../../assets/consume/main/label_total.png" style="width: 50px;">
                                <span class="consume-label-amount">{{item.money}}</span>
                            </div>
                        </div>

                    </div>

                    <div class="consume-main-bottom-view">
                        <div v-if="myConsumeSortListIndex >= 0" class="consume-main-item-view" style="width: 90%;height: 60px;">
                            <div class="consume-main-index">{{consumeMainDataList[myConsumeSortListIndex].ranking}}</div>
                            <div style="width: 36px;height: 36px;position: relative;margin-top: 5px;">
                                <img :src="consumeMainDataList[myConsumeSortListIndex].tx" style="width: 36px;height: 36px;border-radius: 36px;">
                                <img :src="consumeMainDataList[myConsumeSortListIndex].txk" style="width: 50px;height: 50px;position: absolute;top: -7px;left: -7px;">
                            </div>
                            <div v-if="!consumeMainDataList[myConsumeSortListIndex].serverName" class="consume-main-name">
                                {{consumeMainDataList[myConsumeSortListIndex].roleName}}
                            </div>
                            <div v-else class="consume-main-name">
                                <div>{{consumeMainDataList[myConsumeSortListIndex].roleName}}</div>
                                <div style="font-size: 10px;">{{consumeMainDataList[myConsumeSortListIndex].serverName}}</div>
                            </div>
                            <div style="display: flex;flex-direction: column;">
                                <img src="../../assets/consume/main/label_total.png" style="width: 50px;">
                                <span class="consume-label-amount">{{consumeMainDataList[myConsumeSortListIndex].money}}</span>
                            </div>
                        </div>

                        <div v-else class="consume-main-item-view" style="width: 90%;height: 60px;">
                            <img src="../../assets/consume/main/not_in_ranking.png" style="width: 50px;margin-left: 20px;">
                        </div>

                        <div style="height: 60px;display: flex;justify-content: space-between;padding-right: 20px;align-items: center;">
                            <img @click="consumeMainRuleShow = true" src="../../assets/consume/main/button_rule.png" style="width: 65px;height: 50px;">
                            <div style="color: #75321C;font-size: 12px;">
                                <div style="font-weight: bold;">榜单每小时自动刷新</div>
                                <div style="font-size: 10px;">点击空白处关闭</div>
                            </div>
                            <img @click="consumeMainTotalShow = true" src="../../assets/consume/main/button_award.png" style="width: 65px;height: 50px;">
                        </div>
                    </div>
                    <myloading v-show="consumeLoading"></myloading>
                </div>
            </van-popup>

            <van-popup  v-model="consumeMainRuleShow" v-if="consumeMainRuleShow" position="center" :style="{ width: '100%'}" style="background: transparent;">
                <div class="consume-main-rule-view">
                    <img @click="consumeMainRuleShow = false" src="../../assets/consume/dialog/close.png" style="width: 23px;height: 23px;position: absolute;right: 10px;top: 5px;">
                    <div style="text-align: center;font-size: 18px;font-weight: bold;color: #FFFFFF">活动规则</div>
                    <div style="font-size: 14px;font-weight: bold;color: #FFFFFF;margin: 3px 0;">充值排名</div>
                    活动开始时间:{{consumeStartTime}}0点开始<br>
                    活动结束时间:{{consumeEndTime}}24点结束<br>
                    1.榜单统计灵眸黄金服所有区服活动期间充值金额前100名。<br>
                    <div style="margin-left: 15px;">
                        第1名奖励1000商城币<br>
                        第2名奖励500商城币<br>
                        第3名奖励300商城币<br>
                        第4-10名奖励200商城币<br>
                        第11-20名奖励100商城币<br>
                        第21-50名奖励50商城币<br>
                        第51-100名奖励30商城币<br>
                    </div>

                    2.活动每1小时自动刷新一次排行榜<br>
                    3.活动仅展示本次活动时间段充值金额，活动结束将不再刷新排行榜<br>
                    4.活动结束后奖励自动发放<br>
                    <div style="font-size: 14px;font-weight: bold;color: #FFFFFF;margin: 3px 0;">达标奖励</div>
                    活动期间充值金额达到指定金额，可领取达标奖励，达标奖励可叠加领取，每个档位单独领取一次，领取时间不限制。<br>
                </div>
            </van-popup>

            <van-popup  v-model="consumeMainTotalShow" v-if="consumeMainTotalShow" position="center" :style="{ width: '100%'}" style="background: transparent;">
                <div>
                    <div class="consume-main-total-view">
                        <div v-for="item in consumeTotalLevelList" class="consume-main-total-item" :class="myConsumeAmount < item.count && 'consume-main-total-item-disable'">
                            <div style="color: #FFFFFF;flex: 1;display: flex;flex-direction: column;align-items: flex-start;">
                                <div style="display: flex;align-items: center;">
                                    <img src="../../assets/consume/total/label_czdd.png" style="width: 50px;">
                                    <span style="margin-left: 5px;">{{item.count}}</span>
                                </div>
                                <div>{{myConsumeAmount}} / {{item.count}}</div>
                            </div>
                            <div style="display: flex;align-items: center;flex: 1;color: #eeaf11;font-size: 12px;">
                                <div class="consume-total-scb-view">
                                    <div style="margin-left: 10px;margin-top: 26px;">
                                        <span style="font-size: 8px;">X</span>{{item.scb}}
                                    </div>
                                </div>

                                <div v-if="item.cj > 0" class="consume-total-cjcs-view">
                                    <div style="margin-left: 10px;margin-top: 26px;">
                                        <span style="font-size: 8px;">X</span>{{item.cj}}
                                    </div>
                                </div>
                            </div>

                        </div>

                    </div>
                </div>
                <div style="margin-top: 8px;">
                    <img @click="getConsumeAward" src="../../assets/consume/total/button.png" style="width: 100px;">
                </div>
                <myloading v-show="consumeLoading"></myloading>
            </van-popup>

        </div>

        <game-tools v-if="gameToolsEnabled && step === 2 && gameUrl" ref="gameTools" :get-frame="getToolsFrame" :set-rate="setSpeed" :rate="speedRate"
          :session-key="gameId + ':' + gameUrl" @rate-change="speedRate = $event"
          :blocked="mainDialogShow || payShow || payJxfShow || payCodeShow || diyDialogShow || realNameShow || bindTelShow || iframeDialogShow || openPageShow || consumeMainDialogShow || consumePermissionDialogShow || consumePromotionDialogShow || giveGiftPageShow || videoPageDialogShow || hasRedShow" />
    </div>

</template>

<script>
    import {logout, roleSync, request} from '@/api/request'
    import sdkUrl from '@/api/sdkurl'

    import bindTel from "@/components/bindtel.vue";
    import realName from "@/components/realname.vue";
    import pay from "@/components/pay.vue";
    import payJxf from "@/components/pay-jxf";
    import videoPage from "@/components/video.vue";
    import payCode from "@/components/pay-code.vue";
    import loginPage from "@/components/login.vue";
    import GameTools from '@/features/game-tools/GameTools.vue';
    import { GAME_TOOLS_ENABLED } from '@/features/game-tools/availability';
    import SdkFrameShell from '@/components/SdkFrameShell.vue';

    import mainRoundImg from "@/assets/logo-round.png";
    import hasRedIcon from "@/assets/has-red.png";
    import {Dialog, Toast} from 'vant';
    import { localGameEntry } from '@/features/game-tools/game-entry';
    import webConfig from "@/api/config";
    import notice from "@/api/notice";
    import myloading from "@/components/myloading.vue";

    export default {
        name: 'mainPage',
        components: {
            myloading,
            'bind-tel': bindTel,
            'real-name': realName,
            'pay': pay,
            'payJxf': payJxf,
            'videoPage': videoPage,
            'pay-code': payCode,
            loginPage,
            GameTools,
            SdkFrameShell,
        },
        data() {
            return {
                gameToolsEnabled: GAME_TOOLS_ENABLED,
                step: 0,
                mainRoundImg,
                hasRedIcon,
                payShow: false,
                payJxfShow: false,
                mainDialogShow: false,

                bindTelShow: false,
                realNameShow: false,
                openPageShow: false,
                videoPageShow: false,
                videoPageDialogShow: false,
                payDialogShow: false,
                payCodeShow: false,
                iframeDialogShow: false,
                hasRedShow: false,
                diyDialogShow: false,

                flags: false,
                position: {x: 0, y: 0},
                nx: '', ny: '', dx: '', dy: '', xPum: '', yPum: '',
                isShow: false,

                channelId: '',
                gameId: '',

                buttonHidden: true,
                halfOffset: 0,
                time: 10000,
                firstClick: true,
                gameUrl: '',
                tempGameUrl: '',
                payUrl: '',
                screenModel: 1,//当前屏幕方向 1-竖屏 2-横屏
                screenType: 0,//游戏类型 1-竖屏 2-横屏
                dialogStyle: {},
                openPageUrl: '',//外部链接地址

                path: location.protocol + '//' + location.host + '/#' + this.$route.path, //当前页面url
                speedRate: 1,
                jsPageShow: false,
                drawUrl: '',
                hasRed: false,
                shoutId: 0,
                shoutMsgList: [],
                showNotice: false,
                noticeShowSwitch: true,
                noticeStyle: '',
                noticeMessage: '',
                heartBeatGameId: [1, 2, 48],
                skipCheckTel: false,
                iframeUrl: '',
                showJsButton: '0',
                logoRoundUrl: require("@/assets/logo-skeleton.png"),
                isAutoLogin: false,
                showGiveGiftButton: false,
                giveGiftRoleName: '',
                giveGiftPageShow: false,
                giveGiftInputTipsShow: true,
                giveGiftResult : {userName: '无', roleName: '无', serverName: '无', addTime: '无', vip: '无', sendStatus: '无'},

                windowWidth: 0,
                windowHeight: 0,

                pointIndex: 1,
                autoClickPointList: [],
                autoClickStarting: false,
                autoClickSettingShow: false,
                autoClickListShow: false,
                autoClickButtonShow: false,
                createOrUpdatePlan: 1,
                selectAutoClickPlanIndex: -1,
                autoClickPlan: {},
                currentLoopNum: 0,
                androidAppVersion: '',
                acViewLeft: null,

                consumePromotionDialogShow: false,
                hideConsumeDialogValue: false,
                consumePermissionDialogShow: false,
                consumePermissionDialogStep: 1,
                consumePermissionAgree: 0,
                consumeMainDialogShow: false,
                consumeMainDataList: [],
                consumeMainRuleShow: false,
                consumeMainTotalShow: false,
                consumeTotalLevelList: [
                    {count:98, scb: 5, cj: 0},
                    {count:648, scb: 15, cj: 0},
                    {count:1000, scb: 28, cj: 1},
                    {count:3500, scb: 88, cj: 2},
                    {count:7500, scb: 88, cj: 3},
                    {count:15000, scb: 88, cj: 3},
                    {count:25000, scb: 188, cj: 3},
                    {count:40000, scb: 188, cj: 3},
                    {count:65000, scb: 188, cj: 3},
                    {count:100000, scb: 188, cj: 3},
                ],
                consumeStartTime: '-年-月-日',
                consumeEndTime: '-年-月-日',
                myConsumeAmount: 0,
                consumeUserAgreeSet: -1,
                consumeDialogHideToday: '0',
                consumePromotionId: '',
                myConsumeSortListIndex: -1,
                consumeLoading: false,
                iframeStyle: {height: '100vh', marginTop: '0px'},
            };
        },
        watch: {
            giveGiftRoleName(n, o) {
                this.giveGiftInputTipsShow = !n;
            },
            hideConsumeDialogValue(n, o) {
                let value = this.hideConsumeDialogValue ? '1' : '0';
                this.deleteAllHideConsumeStorage();
                let key = this.getHideTodayKey();
                localStorage.setItem(key, value);
            }
        },
        mounted() {
            console.log('页面初始化');
            this.initUrlParams();
            this.transformChannel();
            this.handleLoginStatus();
            this.autoLogin();
            this.isRequestPermission();
            window.confirmLogout = this.confirmLogout;

            this.windowWidth = window.innerWidth;
            this.windowHeight = window.innerHeight;
            this.fixSafeArea();
        },
        methods: {
            getToolsFrame() { return this.$refs.gameIframe; },
            loginSuccessCallBack() {
                this.getGiveButtonPermission();
                this.queryConsumeData();
            },
            getConsumeAward() {
                this.consumeLoading = true;
                let options = {
                    url:"/h5/getConsumeAward?gameId=" + this.gameId,
                    method: 'get',
                };
                request(options).then(res => {
                    this.consumeLoading = false;
                    if (res.data.success) {
                        Toast('奖励领取成功');
                    }
                    else {
                        Toast(res.data.error.message);
                    }
                });
            },
            deleteAllHideConsumeStorage() {
                for (let i = 0; i < localStorage.length; i++) {
                    const key = localStorage.key(i);
                    if (key.startsWith('hideConsumeDialog_')) {
                        localStorage.removeItem(key);
                    }
                }
            },
            openConsumePageFromMenu() {
                let options = {
                    url:"/h5/getConsumePromotionInfo?gameId=" + this.gameId,
                    method: 'get',
                };
                request(options).then(res => {
                    if (res.data.success) {
                        this.myConsumeAmount = res.data.data.myMoney;
                        this.showAndQueryConsumeMainData();
                    }
                    else {
                        Toast(res.data.error.message);
                    }
                });
            },
            openConsumePage() {
                this.consumePromotionDialogShow = false;
                if (this.consumeUserAgreeSet === -1) {
                    this.consumePermissionDialogShow = true;
                }
                else {
                    this.showAndQueryConsumeMainData();
                }
            },
            showAndQueryConsumeMainData() {
                this.consumeMainDataList = [];
                this.consumeLoading = true;
                let options = {
                    url:"/h5/getConsumeSortInfo?gameId=" + this.gameId,
                    method: 'get',
                };
                request(options).then(res => {
                    if (res.data.success) {
                        this.myConsumeSortListIndex = res.data.data.myRanking - 1;
                        this.consumeMainDataList = res.data.data.infoList;
                        this.consumeLoading = false;
                    }
                    else {
                        this.consumeLoading = false;
                        Toast(res.data.error.message);
                    }
                });

                this.consumeMainDialogShow = true;
            },
            submitConsumeUserSet() {
                if (this.consumePermissionAgree === 0) {
                    Toast('请选择是否同意');
                    return;
                }
                let status = this.consumePermissionAgree === 1 ? 1 : 0;
                let options = {
                    url:"/h5/setConsumePromotion?promotionId=" + this.consumePromotionId + "&status=" + status,
                    method: 'get',
                };
                request(options).then(res => {
                    if (res.data.success) {
                        this.consumePermissionDialogShow = false;
                        this.showAndQueryConsumeMainData();
                    }
                    else {
                        Toast(res.data.error.message);
                    }
                });

            },
            queryConsumeData() {
                let options = {
                    url:"/h5/getConsumePromotionInfo?gameId=" + this.gameId,
                    method: 'get',
                };
                request(options).then(res => {
                    if (res.data.success) {
                        //有消费活动展示
                        if(res.data.data.promotionId !== '-1') {
                            this.consumePromotionId = res.data.data.promotionId
                            this.myConsumeAmount = res.data.data.myMoney;
                            this.consumeUserAgreeSet = res.data.data.userSet;

                            let key = this.getHideTodayKey();
                            let isHideToday = localStorage.getItem(key);
                            if (isHideToday !== '1') {
                                this.consumePromotionDialogShow = true;
                            }
                        }

                        res.data.data.startTime && (this.consumeStartTime = res.data.data.startTime);
                        res.data.data.endTime && (this.consumeEndTime = res.data.data.endTime);
                    }
                    else {
                        //Toast(res.data.error.message);
                    }
                });
            },
            getHideTodayKey() {
                let today = this.getTodayStr();
                return 'hideConsumeDialog_' + today;
            },
            getTodayStr() {
                let today = new Date();
                let year = today.getFullYear();
                let month = ('0' + (today.getMonth() + 1)).slice(-2);
                let day = ('0' + today.getDate()).slice(-2);
                let date = year + '' + month + '' + day;
                return date;
            },
            async runAutoClick() {
                let pointNum = this.autoClickPointList.length;
                if (pointNum === 0) {
                    Toast('请先添加触点');
                    return;
                }
                this.autoClickStarting = true;
                if (this.acViewLeft) {
                    let acView = document.getElementById("acSettingView");
                    acView.style.left = (this.acViewLeft + 80) + 'px';
                }
                for (let i = 0; i < pointNum; i++) {
                    this.autoClickPointList[i].show = 0;
                }
                this.currentLoopNum = 0;
                await this.startAutoClick();
            },
            moveEndButton(x, y) {
                let acView = document.getElementById("acSettingView");
                if (acView.style.left) {
                    this.acViewLeft = parseInt(acView.style.left.replace('px', ''));
                    console.log(this.acViewLeft);
                }
            },
            moveEndPoint(target) {
                let centerX = target.offsetLeft + 15;
                let centerY = target.offsetTop + 15;
                let index = parseInt(target.innerText);
                this.autoClickPointList[index - 1].pointX = centerX;
                this.autoClickPointList[index - 1].pointY = centerY;
            },
            stopAutoClick() {
                this.autoClickStarting = false;
                if (this.acViewLeft) {
                    let acView = document.getElementById("acSettingView");
                    acView.style.left = (this.acViewLeft) + 'px';
                }

                let pointNum = this.autoClickPointList.length;
                for (let i = 0; i < pointNum; i++) {
                    this.autoClickPointList[i].show = 1;
                }
            },
            enableAutoClickPlan(index) {
                let planList = JSON.parse(localStorage.getItem('autoClickPlanList')) || [];
                if (index >= planList.length ) {
                    Toast('数据出错了');
                    return;
                }

                this.autoClickPlan = planList[index];
                this.autoClickPointList = this.autoClickPlan.pointList;
                this.pointIndex = this.autoClickPointList.length + 1;
                this.autoClickButtonShow = true;
                this.autoClickListShow = false;
                this.createOrUpdatePlan = 2;
                this.selectAutoClickPlanIndex = index;
            },
            exitAutoClickPlan() {
                this.autoClickButtonShow = false;
                this.autoClickSettingShow = false;
                this.pointIndex = 1;
                this.autoClickPointList = [];
                this.currentLoopNum = 0;
            },
            createNewAutoClickPlan() {
                this.autoClickButtonShow = true;
                this.autoClickListShow = false;
                this.autoClickPointList = [];
                this.pointIndex = 1;
                this.addPoint();
                this.createOrUpdatePlan = 1;
                this.autoClickPlan = {
                    name: '',
                    loopNum: '',
                    loopInterval: '0',
                }
            },
            async startAutoClick() {
                this.currentLoopNum ++;
                let pointNum = this.autoClickPointList.length;
                for (let i = 0; i < pointNum; i++) {
                    let point = this.autoClickPointList[i];
                    await this.sleep(!point.timeInterval ? 1000 : point.timeInterval);

                    if (!this.autoClickStarting) {
                        break;
                    }

                    this.$nextTick(function() {
                        let xPercent = parseFloat((point.pointX / this.windowWidth).toFixed(4));
                        let yPercent = parseFloat((point.pointY / this.windowHeight).toFixed(4));
                        if (window.androidJs) {
                            try {
                                window.androidJs.autoClick(xPercent, yPercent);
                            }
                            catch (e) {
                                Toast('当前版本不支持该功能');
                                this.stopAutoClick();
                            }
                        }
                        else {
                            Toast('当前版本不支持该功能');
                            this.stopAutoClick();
                        }
                    });
                    setTimeout(() => {
                        point.show = 1;
                        setTimeout(() => {
                            if (this.autoClickStarting) {
                                point.show = 0;
                            }
                        },300);
                    },50);

                    //最后一个触点，判断是否继续循环
                    if (i === pointNum - 1) {
                        if (!this.autoClickPlan.loopNum || this.currentLoopNum < parseInt(this.autoClickPlan.loopNum)) {
                            let loopInterval = parseInt(this.autoClickPlan.loopInterval);
                            if (loopInterval > 0) {
                                await this.sleep(loopInterval);
                            }
                            await this.startAutoClick();
                        }
                        else {
                            this.stopAutoClick();
                        }
                    }
                }
            },
            sleep(ms) {
                return new Promise(resolve => setTimeout(resolve, ms));
            },
            addPoint() {
                let index = this.pointIndex ++;
                let x = this.windowWidth * 0.5;
                let y = this.windowHeight * 0.2;
                let point = {timeInterval: null, pointX: x, pointY: y, show: 1};
                this.autoClickPointList.push(point);
                Toast('已添加触点' + index);
            },
            submitGiveGift() {
                if (!this.giveGiftRoleName) {
                    Toast('请输入要赠送的角色名');
                    return;
                }
                let options = {
                    url: `/lingmou/sendWelfare?code=ds&roleName=${this.giveGiftRoleName}&gameId=${this.gameId}`,
                    method: 'get'
                };
                request(options).then(res => {
                    if(res.data.success){
                        Toast('赠送成功');
                        this.giveGiftRoleName = '';
                        this.giveGiftResult.userName = res.data.data.userName;
                        this.giveGiftResult.roleName = res.data.data.roleName;
                        this.giveGiftResult.serverName = res.data.data.serverName;
                        this.giveGiftResult.addTime = res.data.data.addTime;
                        this.giveGiftResult.vip = res.data.data.vip;
                        this.giveGiftResult.sendStatus = '赠送成功 6绑币';
                    }else {
                        this.$toast(res.data.error.message);

                    }
                })
            },
            getGiveButtonPermission() {
                let options = {
                    url:"/lingmou/checkZB?code=ds",
                    method: 'get',
                };
                request(options).then(res => {
                    if (res.data.success) {
                        if(res.data.data === true) {
                            this.showGiveGiftButton = true;
                        }
                    }
                    else {
                        //Toast(res.data.error.message);
                    }
                });
            },
            showGiveGiftPage() {
                this.giveGiftResult.userName = '无';
                this.giveGiftResult.roleName = '无';
                this.giveGiftResult.serverName = '无';
                this.giveGiftResult.addTime = '无';
                this.giveGiftResult.vip = '无';
                this.giveGiftResult.sendStatus = '无';
                this.giveGiftPageShow = true;
            },
            isRequestPermission() {
                let audioGameIds = ['1008'];
                let audioEnable = audioGameIds.indexOf(this.gameId) > -1;
                if (audioEnable && this.from === 'android') {
                    try {
                        //window.androidJs.requestAudioPermission();
                    }catch (e) {}
                }
            },
            initUrlParams() {
                this.from = this.$route.query.from || 'h5';
                console.log('main, from: ' + this.from);
                localStorage.setItem('from', this.from);
                this.channelId = this.$route.path.split('/')[2];
                this.gameId = this.$route.path.split('/')[3];

                //处理同一个浏览器  多个标签打开不同的游戏  之前存的token属于不同的游戏，需要清除 重新登录
                /*let localGameId = localStorage.getItem('gameId');
                if (!!localGameId && localGameId !== this.gameId) {
                    localStorage.removeItem('token');
                    localStorage.removeItem('user');
                }*/

                localStorage.setItem("channelId", this.channelId);
                localStorage.setItem("gameId", this.gameId);

                if (this.$route.query.device) {
                    localStorage.setItem('device', this.$route.query.device);
                }

                if (!localStorage.getItem('udid') && this.$route.query.udid) {
                    localStorage.setItem('udid', this.$route.query.udid);
                }
                if (!localStorage.getItem('udid')) {
                    localStorage.setItem('udid', this.generateUUID());
                }
            },
            autoLogin(){
                let credential = this.$route.query.credential;
                if(!credential){
                    return;
                }
                this.isAutoLogin = true;
                let options = {
                    url:"/web/loginGameWithCredential",
                    data: {
                        userCredential: credential,
                        gameId: this.gameId,
                    }
                };
                request(options).then(res => {
                    let newPath = window.location.origin + '/#' + this.$route.path;
                    console.log(newPath)
                    //window.location.href = newPath;
                    history.replaceState({}, '', newPath);
                    if(res.data.success){
                        localStorage.setItem('token', res.data.data.token);
                        localStorage.setItem('user', JSON.stringify(res.data.data));
                        localStorage.setItem('loginUrl', res.data.data.loginUrl);
                        Toast('登录成功');
                        this.enterGame();
                    }else {
                        this.$toast(res.data.error.message);

                    }
                })
            },
            generateUUID(){
                let d=new Date().getTime();
                let uuid ='xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                    let r = (d + Math.random() * 16) % 16 | 0;
                    d = Math.floor(d / 16);
                    return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
                });
                return uuid;
            },
            transformChannel() {
                let thirdChannel = this.$route.query.thirdChannel || '';
                if (!thirdChannel) {
                    return;
                }
                let options = {
                    url:"/h5/transformChannel?channelConfig=" + thirdChannel,
                    method: 'get',
                };
                request(options).then(res => {
                    if (res.data.success) {
                        let result = res.data.data;
                        console.log('渠道号转化成功，第三方渠道号: ' + thirdChannel + ", 转换结果: " + result);
                        localStorage.setItem("channelId", result);
                    }
                    else {
                        console.log('渠道号转化失败');
                    }
                });
            },
            handleLoginStatus () {
                this.step = 1;
                this.$nextTick(function () {
                    this.$refs.loginPage.from = this.from;
                })
            },
            /*handleLoginStatus() {
                let userInfo = localStorage.getItem('user');
                let token = localStorage.getItem('token');
                console.log('userInfo', !userInfo);
                console.log('token', !token);
                if (!!userInfo && !!token) {
                    let options = {
                        url:"/h5/refreshGame",
                        data: {
                            gameId: this.gameId
                        }
                    };
                    request(options).then(res => {
                        if (res.data.success) {
                            let gameUrl = res.data.data;
                            localStorage.setItem('loginUrl', gameUrl);
                            this.skipCheckTel = true;
                            this.enterGame();
                        }
                        else {
                            this.step = 1;
                            this.$nextTick(function () {
                                this.$refs.loginPage.from = this.from;
                            })
                        }
                    });
                }
                else {
                    this.step = 1;
                    this.$nextTick(function () {
                        this.$refs.loginPage.from = this.from;
                    })
                }
            },*/
            enterGame() {
                this.step = 2;
                let user = JSON.parse(localStorage.getItem("user"));
                if (!!user) {
                    this.screenType = user.screenType;
                }

                //开启心跳的游戏id
                if(this.heartBeatGameId.includes(parseInt(this.gameId))) {
                    this.heartBeat();
                    this.showShoutMsg();
                }

                this.tempGameUrl = localGameEntry(localStorage.getItem('loginUrl'), process.env.VUE_APP_TOOL_LOGIN_LOCAL === '1', window.location.origin);
                localStorage.removeItem('loginUrl');
                this.logoRoundUrl = webConfig.logoRoundUrl;
                this.isShow = true;
                this.$nextTick(function () {
                    //this.start();
                    this.initListener();
                })

                if (this.skipCheckTel) {
                    this.isRealName();
                }
                else {
                    this.isBindPhone();
                }

                this.loginSuccessCallBack();
                if (this.from.includes('speedOn')) {
                    this.showJsButton = "1";
                }
                this.iframeUrl = sdkUrl + "?gameId=" + this.gameId + "&token=" + localStorage.getItem("token") + "&from=" + this.from + "&showJsButton=" + this.showJsButton+ "&noticeSwitch=" + this.noticeShowSwitch;
                // this.iframeUrl = "http://192.168.1.59:8081/f/#/sdk/main?gameId=" + this.gameId + "&token=" + localStorage.getItem("token") + "&from=h5&showJsButton=" + this.showJsButton;
            },
            heartBeat() {
                let options = {
                    url:"/h5/heartBeat",
                    data: {
                        shoutId: this.shoutId,
                        gameId: this.gameId
                    }
                };
                request(options).then(res => {
                    let c = false;
                    if (res.data.success) {
                        let has = res.data.data.redStatus;
                        this.hasRed = has === '1';

                        if (this.hasRed) {//有红包雨活动
                            let redId = res.data.data.redId;
                            let saveRedId = localStorage.getItem('showRedId');
                            if (redId !== saveRedId) {//判断这个红包雨活动是否展示过，已展示的话就不再展示
                                this.hasRedShow = true;
                                localStorage.setItem('showRedId', redId);
                            }
                        }

                        let msgList = res.data.data.shoutMsgList;
                        for (let i = 0; i < msgList.length; i++) {
                            let msg = msgList[i];
                            this.shoutId = msg.id;
                            this.shoutMsgList.push(msg);
                        }
                        c = true;
                    }
                    else {
                        console.log(res.data.error.message);
                        if (res.data.error.code !== '911') {
                            c = true;
                        }
                    }

                    if (c) {
                        setTimeout(() => {
                            this.heartBeat();
                        }, 15000);
                    }

                }).catch(e => {
                    setTimeout(() => {
                        this.heartBeat();
                    }, 15000);
                });
            },
            hideNotice() {
                setTimeout(() => {
                    this.showNotice = false;
                    this.showShoutMsg();
                }, 1000)
            },
            showShoutMsg() {
                if (this.shoutMsgList.length > 0) {
                    let msg = this.shoutMsgList[0];
                    if (this.shoutMsgList.length > 1) {
                        this.shoutMsgList = this.shoutMsgList.slice(1);
                    }
                    else {
                        this.shoutMsgList = [];
                    }

                    let msgResult = '';
                    if (msg.msgType === 1) {
                        this.noticeStyle = '';
                        msgResult = `[${msg.serverName}] ${msg.roleName} ：${msg.msg}`;
                    }
                    else if (msg.msgType === 2) {
                        this.noticeStyle = 'color: #E74C3C; ';
                        msgResult = `官方通知： ${msg.msg}`;
                    }
                    else {
                        msgResult = `${msg.msg}`;
                    }

                    this.noticeMessage = '                                                                                                    ' + msgResult;
                    this.noticeShowTime = new Date().getTime();
                    //this.showNotice = true;
                    this.showNotice = this.noticeShowSwitch;
                    console.log('开始播放时间', this.noticeShowTime)
                }
                else {
                    setTimeout(() => {
                        this.showShoutMsg();
                    }, 3000);
                }
            },
            async setSpeed(n) {
                if (!GAME_TOOLS_ENABLED) throw new Error('游戏工具暂未开放');
                n = Number(n);
                if (!Number.isFinite(n) || n < 0.1 || n > 999) throw new Error('倍率需为 0.1 至 999');
                if (!this.$refs.gameTools) throw new Error('请先登录并进入游戏');
                this.speedRate = await this.$refs.gameTools.setGameRate(n);
                //Toast('游戏当前加速倍率：' + n);
            },
            isBindPhone() {
                let user = JSON.parse(localStorage.getItem("user"));
                if (!user.phone) {
                    this.bindTelShow = true;
                    this.$nextTick(function () {
                        this.$refs.bindTelDialog.backShow = false;
                        this.$refs.bindTelDialog.missShow = true;
                    })
                } else {
                    this.isRealName();
                }
            },
            missBindTel() {
                this.bindTelShow = false;
                this.isRealName();
            },
            isRealName() {
                let user = JSON.parse(localStorage.getItem("user"));
                if (user.isUserCheck !== '1') {
                    this.realNameShow = true;
                    this.$nextTick(function () {
                        this.$refs.realNameDialog.inputEnable = true;
                        this.$refs.realNameDialog.missShow = user.forcePersonCheck !== '1';
                    })
                } else {
                    this.gameUrl = this.tempGameUrl;
                    /*if (user.userName === 'test333' || user.userName === '653426610') {

                        Toast("安全区高度: " + this.getEnvInset('top'));
                    }*/

                    //this.gameUrl = 'https://game.etuw.cn/#/test';
                }
            },
            fixSafeArea() {
                let ua = navigator.userAgent.toLowerCase();
                if (/iphone|ipad|ipod/.test(ua)) {//判断是否ios
                    return;
                }
                const MAX_REASONABLE = 60; // px，超过这个值就认为异常
                const FALLBACK_TOP = 40;   // px，Android 标准状态栏高度
                //const FALLBACK_BOTTOM = 0; // 底部通常不需要额外留白

                let safeTop = this.getEnvInset('top');
                //safeTop = 96;
                //let safeBottom = getEnvInset('bottom');

                if (safeTop > MAX_REASONABLE) {
                    console.warn(`[SafeArea] top env ${safeTop}px abnormal, fallback to ${FALLBACK_TOP}px`);
                    safeTop = FALLBACK_TOP;
                    //this.$refs.mainPage.style.backgroundColor = "#000000";
                }
                /*if (safeBottom > MAX_REASONABLE) {
                    safeBottom = FALLBACK_BOTTOM;
                }*/
                //document.documentElement.style.setProperty('--safe-top', safeTop + 'px');
                //document.documentElement.style.setProperty('--safe-bottom', safeBottom + 'px');
                this.iframeStyle = {
                    height: `calc(100vh - ${safeTop}px)`,
                    marginTop: `${safeTop}px`
                };
            },
            getEnvInset(property) {
                const div = document.createElement('div');
                div.style.cssText = 'position:fixed;top:0;left:0;width:0;height:0;';
                div.style.paddingTop = `env(safe-area-inset-${property}, 0px)`;
                document.body.appendChild(div);
                const value = parseFloat(getComputedStyle(div).paddingTop) || 0;
                div.remove();
                return value;
            },
            missRealName() {
                this.realNameShow = false;
                this.gameUrl = this.tempGameUrl;
            },
            openFuliPageFromRed(url) {
                this.hasRedShow = false;
                this.openFuliPage(url);
            },
            openFuliPage(url) {
                // this.drawUrl = 'https://tao648.cn/w/';
                if (this.gameId === "1013") {
                    this.drawUrl = url;
                }else {
                    this.drawUrl = 'https://game.etuw.cn/w' + '?gameId=' + this.gameId + '&token=' + localStorage.getItem("token");
                }
                this.iframeDialogShow = true;
            },
            initListener() {
                window.addEventListener("message", this.listener);
            },
            listener(event) {
                // Game messages can include signed login URLs; do not log payloads.
                let me = this;
                if (event.data.operation === 'pay') {
                    console.log("触发支付");
                    let order = event.data.param;
                    me.openPayPage(order);
                } else if (event.data.operation === 'uploadGameRole') {
                    console.log("触发角色上报");
                    let param = event.data.param;
                    me.uploadRole(param);
                } else if (event.data.operation === 'repeatLogin') {
                    console.log("触发登陆被顶");
                    me.logout();
                } else if(event.data.operation === 'closeMenu') {
                    this.closeMainWindow();
                } else if(event.data.operation === 'logout'){
                    this.logout();
                } else if(event.data.operation === "startIntent") {
                    Toast(event.data.param.message);
                } else if (event.data.operation === 'showIOSPay') {
                    this.closeMainWindow();
                    this.payUrl = event.data.url;
                    this.diyDialogShow = true;
                } else if(event.data.operation === 'gameSpeed') {
                    if (!GAME_TOOLS_ENABLED) return;
                    this.setSpeed(event.data.param.speed).catch(e => Toast(e.message));
                } else if(event.data.operation === 'openFullDialog') {
                    this.openFuliPageFromRed(event.data.url);
                } else if(event.data.operation === 'noticeSwitch') {
                    this.noticeShowSwitch = !this.noticeShowSwitch;
                }
                else if (event.data.operation === 'openAutoClick') {
                    if (!GAME_TOOLS_ENABLED) return;
                    this.closeMainWindow();
                    this.$nextTick(() => { if (this.$refs.gameTools) this.$refs.gameTools.show('clicker'); });
                }
                else if (event.data.operation === 'openConsumePage') {
                    this.openConsumePageFromMenu();
                }

                /*else if(event.data.operation === 'giveGift') {
                    this.closeMainWindow();
                    this.showGiveGiftPage();
                }*/


            },
            uploadRole(roleParam) {
                let params = {
                    channelId: this.channelId,
                    gameId: roleParam.gameId,
                    userId: roleParam.userId,
                    roleId: roleParam.roleId,
                    roleLevel: roleParam.roleLevel,
                    vipLevel: roleParam.vipLevel,
                    roleName: roleParam.roleName,
                    serverId: roleParam.serverId,
                    serverName: roleParam.serverName,
                    combatNum: roleParam.combatNum,
                    partyId: roleParam.partyId,
                    partyName: roleParam.partyName,
                    partyMasterId: roleParam.partyMasterId,
                    partyMasterName: roleParam.partyMasterName,
                    eventType: roleParam.eventType,
                    cpExt: roleParam.cpExt,
                    sign: roleParam.sign,
                }
                roleSync(params).then(res => {
                    if (res.data.success) {
                        this.$refs.gameIframe.contentWindow.postMessage({operation: "onRole", param: 'success'}, "*");
                    } else {
                        console.log(res.data.error.message);
                    }
                });
            },
            start() {
                this.$refs.countDown.reset();
                this.$refs.countDown.start();
            },
            reset() {
                this.$refs.countDown.reset();
            },
            finish() {
                this.unActiveButton();
            },
            //实现移动端拖拽
            down(event) {
                this.flags = true;
                let touch;
                if (event.touches) {
                    touch = event.touches[0];
                } else {
                    touch = event;
                }
                this.position.x = touch.clientX;
                this.position.y = touch.clientY;
                this.dx = moveDiv.offsetLeft;
                this.dy = moveDiv.offsetTop;
            },
            move(event) {
                if (this.flags) {
                    if (this.buttonHidden) {
                        this.activeButton();
                    }
                    let touch;
                    if (event.touches) {
                        touch = event.touches[0];
                    } else {
                        touch = event;
                    }
                    this.nx = touch.clientX - this.position.x;
                    this.ny = touch.clientY - this.position.y;
                    this.xPum = this.dx + this.nx;
                    this.yPum = this.dy + this.ny;
                    moveDiv.style.left = this.xPum + "px";
                    moveDiv.style.top = this.yPum + "px";
                    //阻止页面的滑动默认事件；如果碰到滑动问题，1.2 请注意是否获取到 touchmove
                    document.addEventListener("touchmove", function () {
                        event.preventDefault();
                    }, false);
                }
            },
            end(event) {

                this.flags = false;
                if (!this.xPum) {
                    return;
                }

                let {
                    clientHeight: windowHeight,
                    clientWidth: windowWidth
                } = document.documentElement;
                // 计算后坐标  设置 按钮位置
                //this.halfOffset = -moveDiv.clientWidth / 2;
                if (this.yPum > 50 && this.yPum < (windowHeight - 150)) { //  不在顶部 且 不在底部
                    if (this.xPum <= (windowWidth / 2)) {  //  left 小于等于屏幕一半
                        moveDiv.style.left = 0;
                        moveDiv.style.right = 'auto';
                        //this.hiddenOnLeft();
                        this.start();
                    } else { //  left 大于屏幕一半
                        moveDiv.style.left = 'auto';
                        moveDiv.style.right = 0;
                        this.start();
                    }
                } else {
                    if (this.yPum <= 50) {  //  在顶部
                        moveDiv.style.top = 0;
                        moveDiv.style.bottom = 'auto';
                        this.start();
                    } else if (this.yPum >= (windowHeight - 150)) {
                        moveDiv.style.bottom = 0;
                        moveDiv.style.top = 'auto';
                        this.start();
                    }
                    if (this.xPum < 0) {
                        moveDiv.style.left = 0;
                        this.start();
                    } else if (this.xPum > (windowWidth - moveDiv.clientWidth)) {
                        moveDiv.style.right = 0;
                        moveDiv.style.left = 'auto';
                        this.start();
                    }
                }
            },
            activeButton() {
                //moveDiv.style.opacity = 1;
                this.buttonHidden = false;
                if (!moveDiv.style.left) {
                    moveDiv.style.left = "0px"
                }

                if (moveDiv.style.left === '-25px') {
                    moveDiv.style.left = "0px"
                } else if (moveDiv.style.right === '-25px') {
                    moveDiv.style.right = "0px"
                }
                /*moveDiv.style.transform = `translate3d(${this.halfOffset+'px'}, 0, 0)`;
                moveDiv.style.transition = 'transform 1s linear 0s';*/
            },
            unActiveButton() {
                //moveDiv.style.opacity = 0.2;
                this.buttonHidden = true;
                if (moveDiv.style.left === '0px') {
                    moveDiv.style.left = "-25px"
                } else if (moveDiv.style.right === '0px') {
                    moveDiv.style.right = "-25px"
                }

                /*moveDiv.style.transform = `translate3d(${this.halfOffset+'px'}, 0, 0)`;
                moveDiv.style.transition = 'transform 1s linear 0s';*/
            },
            showMainWindow() {
                if (this.buttonHidden) {
                    this.activeButton();
                    this.start();
                    return;
                }
                /*if (this.firstClick) {
                  this.firstClick = false;
                  return;
                }*/
                this.iframeUrl = sdkUrl + "?gameId=" + this.gameId + "&token=" + localStorage.getItem("token") + "&from=" + this.from + "&showJsButton=" + this.showJsButton+ "&noticeSwitch=" + this.noticeShowSwitch;
                this.jsPageShow = false;
                this.mainDialogShow = true;
                this.$nextTick(function () {
                    //this.$refs.mainDialog.getBalance();
                })
            },
            closeMainWindow() {
                this.mainDialogShow = false;
                this.activeButton();
                this.start();
            },
            openOutsidePage(title, src, type) {
                /*this.videoPageDialogShow = true;
                this.videoPageShow = true;
                this.$nextTick(function () {
                  this.$refs.videoPage.show(title, src, type);
                })*/
                //this.$refs.webview_iframe.document.location.reload();
                //window.parent.document.getElementById('iframe');
                this.$refs.webview_iframe.contentWindow.location.reload(true);
                console.log(this.$refs.webview_iframe.contentWindow);
                this.closeMainWindow();
                let user = JSON.parse(localStorage.getItem('user'));
                this.openPageUrl = window.location.origin + user.webviewPageUrl;
                this.openPageShow = true;
            },
            closeOutsidePage() {
                this.openPageShow = false;
            },
            closeLuckyPage() {
                this.videoPageShow = false;
                this.videoPageDialogShow = false;
            },
            testPay() {
                let order = {
                    goodsName: '测试商品',
                    money: '200',
                    gameId: '101',
                };
                this.openPayPage(order);
            },
            openPayPage(order) {
                if (this.gameId === '48' || this.gameId === '1' || this.gameId === '2' || this.gameId === '1008') {
                    this.payJxfShow = true;
                    this.$nextTick(function () {
                        this.$refs.payJxf.initOrder(order);
                        this.$refs.payJxf.getBalance();
                    })
                }
                else {
                    this.payShow = true;
                    this.$nextTick(function () {
                        this.$refs.pay.initOrder(order);
                        this.$refs.pay.getBalance();
                    })
                }

            },
            openPayUrl(url, payType, price, oPrice, orderId) {
                this.payShow = false;
                if (this.isMobile()) {
                    this.payUrl = url;
                    let ua = navigator.userAgent.toLowerCase();
                    if (/iphone|ipad|ipod/.test(ua)) {//判断是否ios
                        this.diyDialogShow = true;
                    } else {
                        window.open(this.payUrl, '');
                    }
                } else {
                    this.payCodeShow = true;
                    this.$nextTick(function () {
                        let data = {
                            payCode: url,
                            payType: payType,
                            payPrice: price,
                            payOriginalPrice: oPrice,
                            orderId: orderId,
                        }
                        this.$refs.payCode.init(data);
                    });

                }

            },
            refreshPage() {
                this.gameUrl = '';
                setTimeout(() => {
                    this.gameUrl = this.tempGameUrl;
                }, 1000)

            },
            closeDiyDialog() {
                this.diyDialogShow = false;
            },
            isMobile() {
                return navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
            },
            closePayPage() {
                this.payShow = false;
            },
            closeJxfPayPage() {
                this.payJxfShow = false;
            },
            confirmLogout() {
                Dialog.confirm({
                    message: '确认要退出登录吗?',
                }).then(() => {
                    this.logout();
                })
            },
            logout() {
                logout().then(res => {
                    this.logoutCallback();
                })
            },
            logoutCallback() {
                window.removeEventListener("message", this.listener);
                localStorage.removeItem('token');
                localStorage.removeItem('user');
                localStorage.removeItem('loginUrl');
                Toast('已退出登录');
                this.mainDialogShow = false;
                this.bindTelShow = false;
                this.realNameShow = false;
                this.openPageShow = false;
                this.videoPageShow = false;
                this.videoPageDialogShow = false;
                this.payDialogShow = false;
                this.payCodeShow = false;
                this.diyDialogShow = false;
                this.step = 1;
                this.gameUrl = null;
                if (this.isAutoLogin) {
                    notice.exitGame();
                }
                else {
                    window.location.reload();
                }
            },
        }
    }
</script>

<style scoped>
    .main-dialog {
        background-color: #2f2f2f;
        width: 88%;
        max-width: 300px;
        height: 320px;
        padding-bottom: 5px;
        border: 1px solid #484848;
        /*box-shadow: 2px 2px 10px 3px rgba(255,255,255,.2);*/
    }

    .pay-code-dialog {
        width: 88%;
        padding-bottom: 5px;
        max-width: 300px;
    }

    .pay-dialog {
        background-color: #2f2f2f;
        width: 88%;
        max-width: 300px;
    }

    .main-page {
        position: relative;
        background-color: #ffffff;
        width: 100%;
        height: 100vh;
        overflow: hidden;
        touch-action: none;
        margin: 0 auto;
    }

    .iframe-dialog {
        background-color: #ffffff;
        width: 100vw;
        height: 100vh;
        padding: 0;
        overflow: hidden;
    }

    .back-div {
        background-color: #eceaea;
    }

    .right-panel {
        position: absolute;
        background-color: white;
        width: 100%;
        height: 95%;
        top: 5%;
        right: 0;
    }

    .dialog-mask {
        width: 100vw;
        height: 100vh;
        overflow: hidden;
        background-color: rgba(0, 0, 0, 0.4);
        position: absolute;
        top: 0;
        left: 0;
    }

    .diy-dialog {
        background-color: #ffffff;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding: 10px 8px 1px 8px;
        box-sizing: border-box;
        text-align: left;
        font-size: 14px;
        width: 80%;
        max-width: 300px;
        border-radius: 10px;
        margin: 200px auto 0;

    }

    .diy-dialog-buttons {
        padding: 0 15px;
        font-size: 14px;
        display: flex;
        justify-content: space-between;
        margin-bottom: 0;
        margin-top: 30px;
        border-top: 1px solid #f0f0f0;
    }

    .zeng-icon-view {
        position: fixed;
        touch-action: none;
        height: 40px;
        width: 8px;
        z-index: 999;
        bottom: 20%;
        left: 0;
        background-color: #f34e38;
    }

    .xuanfu {
        position: fixed;
        touch-action: none;
        height: 50px;
        width: 50px;
        /* 如果碰到滑动问题，1.3 请检查 z-index。z-index需比web大一级*/
        z-index: 999;
        top: 60%;
        left: -25px;
    }
    /deep/.van-notice-bar__content{
        white-space:pre;
    }
    @keyframes changeIconSize {
        0% {
            transform: scale(1);
        }
        50% {
            transform: scale(1.2);
        }
        100% {
            transform: scale(1);
        }
    }
    .has-red-icon {
        animation: changeIconSize 1s infinite alternate;
    }
    .give-top-bg {
        width: 240px;
        background: url("../../assets/give/top_bg.png");
        background-size: 100% 100%;
        color: #FFFFFF;
        font-size: 12px;
        padding: 15px 0;
    }
    .give-main-bg {
        position: relative;
        width: 100%;
        color: #FFFFFF;
    }
    .give-top-line {
        display: flex;
        align-items: center;
    }
    .give-gift-view {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100vh;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-top: 100px;
    }

    .auto-click-view {
        font-size: 10px;
        position: absolute;
        right: 10px;
        top: 70%;
        user-select: none;
        cursor: pointer;
        background-color: #3a3a3a;
        padding: 8px 0;
        border-radius: 4px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #e73d50;
    }
    .rp-view {
        background-color: rgba(0, 0, 0, 0.7);
        box-sizing: border-box;
        width: 30px;
        height: 30px;
        border-radius: 30px;
        position: absolute;
        color: #cccccc;
        font-weight: bold;
        display: flex;
        align-items: center;
        justify-content: center;
        user-select: none;
        cursor: pointer;
    }
    .cp-dialog-view {
        background: url("../../assets/consume/permission/bg_main.png");
        background-size: 100% 100%;
        width: 320px;
        box-sizing: border-box;
        height: 55vh;
        margin: 0 auto;
        padding: 55px 20px 10px;
        position: relative;
    }
    .van-popup {
        overflow: hidden;
    }
    .consume-main-view {
        //background: url("../../assets/consume/main/bg_main.png");
        //background-size: 100% 100%;
        width: 320px;
        box-sizing: border-box;
        height: 70vh;
        margin: 0 auto;
        padding: 0;
        position: relative;
    }
    .consume-top3-view {
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin-top: 20px;
    }
    .consume-top3-name-view {
        background: url("../../assets/consume/main/top3_bg.png");
        background-size: 100% 100%;
        width: 90%;
        height: 34px;
        box-sizing: border-box;
        margin-top: 10px;
        color: #FFFFFF;
        font-size: 11px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }
    .consume-label-amount {
        font-size: 20px;
        font-weight: bold;
        /*background: linear-gradient(0deg, #e8d0ad 15%, #e0840c 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        -webkit-text-stroke: 0.5px #e8deba;*/
        color: #ef6b0c;
        -webkit-text-stroke: 0.5px rgb(243, 240, 237);
    }
    .consume-main-list-view {
        width: 100%;
        height: calc(70% - 155px);
        margin-top: 35px;
        overflow-y: auto;
        -ms-overflow-style: none;  /* IE 和 Edge */
        scrollbar-width: none;/* Firefox */
    }
    .consume-main-list-view::-webkit-scrollbar {
        display: none;/* 兼容 Chrome, Opera, 和 Safari */
    }

    .consume-main-item-view {
        background: url("../../assets/consume/main/ranking_bg.png");
        background-size: 100% 100%;
        width: 80%;
        height: 50px;
        margin: 0 auto;
        display: flex;
        align-items: center;
        padding: 0 5px;
        box-sizing: border-box;
    }
    .consume-main-bottom-view {
        width: 100%;
        height: 120px;
        position: absolute;
        bottom: 0;
    }
    .consume-main-index {
        color: #9B4D21;
        width: 36px;
        font-size: 18px;
        font-weight: bold;
        display: flex;
        align-items: center;
        justify-content: flex-start;
    }
    .consume-main-name {
        flex: 1;
        font-size: 13px;
        color: #444444;
        font-weight: bold;
    }
    .consume-main-rule-view {
        background: url("../../assets/consume/main/bg_rule.png");
        background-size: 100% 100%;
        width: 320px;
        box-sizing: border-box;
        margin: 0 auto;
        text-align: left;
        color: #e0d5d5;
        font-size: 12px;
        padding: 10px 15px;
        border-radius: 4px;
        position: relative;
    }
    .consume-main-total-view {
        background: url("../../assets/consume/total/bg_main.png");
        background-size: 100% 100%;
        width: 320px;
        margin: 0 auto;
        padding: 55px 8px 8px;
        box-sizing: border-box;
    }
    .consume-main-total-item {
        background: url("../../assets/consume/total/bg_item.png");
        background-size: 100% 100%;
        width: 100%;
        height: 55px;
        margin: 0 auto;
        display: flex;
        align-items: center;
        padding: 10px 15px;
        box-sizing: border-box;
    }
    .consume-main-total-item-disable {
        //background: url("../../assets/consume/total/bg_item_disable.png") !important;
        opacity: .4;
    }
    .consume-total-scb-view {
        background: url("../../assets/consume/total/bg_scb.png");
        background-size: 100% 100%;
        width: 40px;
        height: 40px;
    }
    .consume-total-cjcs-view {
        background: url("../../assets/consume/total/bg_jgz.png");
        background-size: 100% 100%;
        width: 40px;
        height: 40px;
        margin-left: 20px;
    }
</style>
